import { Box } from '@mui/material';
import { AdviseCurrentSupplier } from '../../../../types/advise';
import { TextSpan } from '../../../Atoms/Text';
import { CARD_ACTION_LINK } from './supplierCardStyles';

/** How a supplier's spend was entered by hand, or null when its invoices carry it. */
export const manualEntryNote = ({ spend_entry, invoices }: AdviseCurrentSupplier): string | null => {
  if (spend_entry === 'monthly_total') {
    return invoices.length > 0
      ? 'Monthly total entered manually — invoices aren’t counted.'
      : 'No invoice — monthly total entered manually.';
  }
  if (spend_entry === 'line_items' && invoices.length === 0) return 'No invoice — line items entered manually.';
  return null;
};

export interface ManualEntryNoteProps {
  note: string;
  canEdit: boolean;
  onOpen: () => void;
}

/** A note on hand-entered spend, with Edit for an editor and View for anyone else. */
export const ManualEntryNote = ({ note, canEdit, onOpen }: ManualEntryNoteProps) => (
  <Box className="flex items-center gap-1">
    <TextSpan
      size="sm"
      color="grey6">
      {note}
    </TextSpan>
    <button
      type="button"
      className={CARD_ACTION_LINK}
      onClick={onOpen}>
      {canEdit ? 'Edit' : 'View'}
    </button>
  </Box>
);
